import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=90d4ae1a&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"
import style0 from "./Chips.vue?vue&type=style&index=0&id=90d4ae1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d4ae1a",
  null
  
)

export default component.exports